import { Button, ButtonColors, Modal } from "@talentech/components";
import React from "react";

interface ConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  variant?: ButtonColors;
  children: React.ReactNode;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onClose,
  onConfirm,
  title = "Confirm Action",
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  variant = ButtonColors.PRIMARY,
  children,
}) => {

    const [isLoading, setIsLoading] = React.useState(false);

    const onConfirmation = async () => {
        setIsLoading(true);
        await onConfirm();
        setIsLoading(false);
    } 

  return (
    <Modal
      showModal={show}
      onClose={onClose}
      size="md"
      title={title}
      buttons={[
        <Button color={ButtonColors.PRIMARY} onClick={onClose} label={cancelButtonText} outline key="cancel" />,
        <Button color={variant} onClick={onConfirmation} label={confirmButtonText} {...{isLoading}} key="confirm"/>
      ]}
    >
      {children}
    </Modal>
  );
};

export default ConfirmationModal;
